import React from "react";
import SvgEmail from "components/svg/Email";

const SolutionFactoryCell = ({ config, data }) => {

    const renderSolutionFactory = (value) => {
        if (!value) {
            return null;
        }

        return <>
            {value ? <>
                {value}<br />
            </> : null}
        </>
    }

    const splitEmails = (emailValue) => {
        if (!emailValue) return [];
        if (emailValue.includes(";")) return emailValue.split(";").map(e => e.trim()).filter(e => e.length > 0);
        if (emailValue.includes(",")) return emailValue.split(",").map(e => e.trim()).filter(e => e.length > 0);
        return [emailValue.trim()];
    }

    const renderEmail = (emailValue) => {
        if (!emailValue) {
            return null;
        }

        const emails = splitEmails(emailValue);
        return <>
            {emails.map((email, i) => (
                <React.Fragment key={i}>
                    <SvgEmail />{" " + email}<br />
                </React.Fragment>
            ))}
        </>
    }

    return data ? <>
        {renderSolutionFactory(data.label)}
        {renderEmail(data.value.email)}
    </> : null;
}

export default SolutionFactoryCell;